import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_DESPACHOS_ARRECADACAO = `${modulo.ARRECADACAO}/despachos`

const actions = {
  async save ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `${URL_DESPACHOS_ARRECADACAO}`
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/despachos.js